import React, { useState, useEffect } from 'react'
import Card from '../CustomComponents/Card'
import { withOidcSecure } from '@axa-fr/react-oidc'
import { height, width } from "../CustomComponents/DynamicCard/DynamicCardStyles";
import { addLineBreaks } from '../../utils';
import { useTranslation } from 'react-i18next';
import { useSelector , useDispatch} from 'react-redux';
import HomeLayout from '../Layout/HomeLayout';
import LeftBar from '../CustomComponents/DynamicComponent/LeftBar';
import DynamicCard from '../CustomComponents/DynamicCard';
import Bell from '../../assets/images/Bell.png'
import arrow from '../../assets/images/Caret_S.png'
import { useNavigate, Link } from 'react-router-dom';
import FooterContent from '../CustomComponents/Footer';
import dotCircle from '../../assets/images/dotCircle.png'
// import newImage from '../../assets/images/New.png'
import newImage from '../../assets/kudzu-plus-images/New.png'

// import HomeLayout from '../Layout/HomeLayout';
import HomeHeader from '../CustomComponents/HomeHeader';
import DynamicHomeCard from '../CustomComponents/DynamicHomeCard';
import { useKeyDown } from '../../hooks/useKeyDown';
import logFirebaseEvents from '../LogFirebaseEvents';
import { appTheme, showKudzuPlusPrompt, showPrompt } from '../../helpers/utils/Utils';
import { PAID_PROMO_KEY, TRAIL_PROMO_KEY } from '../../network/URLConstants';
import { getUserMembership } from '../../helpers/utils/Utils';
import Ach_acces from '../../assets/kudzu-plus-images/ach_acces.png'
import Checkbox from '../../assets/kudzu-plus-images/checkbox.png'
import SavingsInteresrRate from '../../assets/kudzu-plus-images/SavingsInteresrRate.png'
import GradientArrow from '../../assets/kudzu-plus-images/gradientArrow.png'
import Security from '../../assets/kudzu-plus-images/security.png'
import CoveredbyKudzuplus from '../../assets/kudzu-plus-images/CoveredbyKudzuplus.png'
import ATM_small from '../../assets/kudzu-plus-images/ATM_small.png'
import Frame from '../../assets/kudzu-plus-images/Frame.png'
import CardHeading from '../CustomComponents/CardHeading';
import Approved from '../../assets/images/Green_Tick.png'
import { HeaderCaption, Space, Title, Main, CardSection, Container, CardTitle, CardFooter, CardHeader } from "../CustomComponents/DynamicCard/DynamicCardStyles";
import { useLocation } from 'react-router';
import CustomModalPlus from '../../kudzu_plus/helpers/customModalPlus';
import image from '../../assets/images/image.png'
import kudzuLogo from '../../assets/images/kudzuLogo.png'
import { END_SESSION } from '../../network/URLConstants';
import rootReducer from '../../Redux/reducers'
import { createStore } from 'redux';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';


const Settings = () => {
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);
    const { t } = useTranslation();
    useDocumentTitle(t('page_title_settings'));
    
    const navigate = useNavigate();
    const cards = useSelector(state => JSON.parse(state.userCards));
    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const showPrompt = showKudzuPlusPrompt(loggedResponse);
    const [focusedIndex, setFocusedIndex] = useState(0);
    const [promoKey, setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);
    const isSmiOneIsTrue = useSelector(state => state.smiOneAccountTrue);
    const hasSavingsAccount = cards?.some(item => item.AccountTypeName === "Savings");
    const userMembershipData = getUserMembership(loggedResponse)
    const [isShowManageMemberShip, setIsShowManageMemberShip] = useState(false);
    const location = useLocation()
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const settingListItem = 'cursor-pointer font-hanken-grotesk font-[600]  lg:text-[16px] md:text-[14px] sm:text-[14px] text-[15px] leading-[20px] md:font-[700] md:leading-[16px] lg:leading-[16px] text-[#FEFAEE]';
   
    const settingListItemManageMember = `cursor-pointer font-hanken-grotesk font-[600] lg:text-[16px] md:text-[14px] sm:text-[14px] text-[15px] 
    leading-[20px] md:font-[700] md:leading-[16px] lg:leading-[16px] 
    ${isShowManageMemberShip ? 'text-[#94C3E8]' : 'text-[#FEFAEE]'}`;
    const SubHeaderMsgPlusStyles = "sm:w-[399px] font-hanken-grotesk modal-title mt-[17px] md:text-[16px] sm:text-[14px] text-[16px] sm:leading-[27px] lg:leading-[30px] md:leading-[30px] leading-[30px] font-[400] cursor-pointer text-white";
    const HeaderMsgStylesForPlus = "w-[240px] md:w-[399px] font-serif-pro text-white modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";

    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [showModel, setShowModel] = useState(false);
    const [modelImage, setModelImage] = useState('')
    const [savingsTheme, setSavingsTheme] = useState(false);
    const [isBorderNone, setisBorderNone] = useState(true);
    const [isSubFooter, setIsSubFooter] = useState(false);
    const [summaryParagraph, setSummaryParagraph] = useState('');
    const [opacityValueLow, setOpacityValueLow] = useState(false);
    const [showPlusModal, setShowPlusModal] = useState(false);
    const [comparisonScreen, setComparisonScreen] = useState('');
    const [fullWidth, setFullWidth] = useState(false);
    const [footerButtonEnable, setFooterButtonEnable] = useState(false);
    const [gradientButton, setGradientButton] = useState(false);
    const [largeImage, setLargeImage] = useState(false);
    const [allButtonsDisable, setAllButtonsDisable] = useState(false);
    const [btn1TextColor, setBtn1TextColor] = useState("");
    const [footerText, setFooterText] = useState("");

    const [carousel, setCarousel] = useState('');
    const [btn1BgColor, setBtn1BgColor] = useState("");

    const [comparisonClickFrom, setComparisonClickFrom] = useState("");
    const hasKudzuCard = useSelector((state) => state.hasKudzuCard);

    const isB2c = useSelector(state => state.preferredIdentity);
    const accessTokenToApi = useSelector(state => state.accessToken);
    const appConfigData = useSelector(state => state.appConfigData);
    const store = createStore(rootReducer);

    const handleComparisonBackClick = () =>{
        navigate("/home")
   }

    const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists,
        btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor,
        summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable,
        gradientButton, largeImage, allButtonsDisable,btn1TextColor,footerText) => {
        setShowPlusModal(showPlusModal)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setBtn1Exists(btn1Exists)
        setBtn1Text(btn1Text)
        setCarousel(carousel)
        setisBorderNone(isBorderNone)
        setBtn1BgColor(btn1BgColor)
        setSummaryParagraph(summaryParagraph)
        setOpacityValueLow(opacityValue)
        setComparisonScreen(comparisonScreen)
        setFullWidth(fullWidth)
        setFooterButtonEnable(footerButtonEnable)
        setGradientButton(gradientButton)
        setLargeImage(largeImage)
        setAllButtonsDisable(allButtonsDisable)
        setBtn1TextColor(btn1TextColor)
        setFooterText(footerText)

    }

     const onAcptBtnClickPlusModal = () => {
            if (btn1Text === t('setup_direct_deposit')) {
                navigate("/AccountServices/Spending/ManageDirectDeposit");
            }
            else if (btn1Text === t('enroll_in_savings') ) {
                navigate("/SetupSavingsAccount");
            }
            else if(btn1Text === t('goto_savings')){
              navigate("/Savings");
            }
            else if (btn1Text === t('get_covered')) {
                navigate("/Toolkit/ToolkitMenu");
            }
    
            else if (btn1Text === t('create_savings_goal')) {
                navigate("/Toolkit/ToolkitMenu");
            }
    
            else if (btn1Text === t('findATMBtn')) {
                navigate("/Help/FindATM");
            }
    
            else {
                logFirebaseEvents("ManageMembershipCancelation", "downgrade_to_kudzu_Clicked", "downgrade_to_kudzu_Clicked", "", "");
                navigate("/kudzuplusSecurity", { state: { type: t('downgrad_to_kudzu_plus') } });
            }
    
        }
    
    const onCancelBtnClickPlusModal = () => {
            logFirebaseEvents("ManageMembershipCancelation", "Cancel_clicked", "Cancel_clicked  ", "", "");
            setIsLoading(true)
            setTimeout(() => {
            setIsLoading(false)
            setShowPlusModal(false)
            navigate("/home");
            }, 1000);
     }

    const closeModelPlus = () => {
       // setShowCarouselScreensShow(false);
        logFirebaseEvents("ManageMembershipCancelation", "Close_clicked", "Close_clicked", "", "");
        setShowPlusModal(false)
    }

    const handleCancelMembership = () => {
            logFirebaseEvents("ManageMembershipCancelation", "Cancel_Kudzu+_Membership_Clicked", "Cancel_Kudzu+_Membership_Clicked", "", "");
            const currentPath = { currentPathFromStore: location.pathname };
            dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
            console.log("userMembershipData?.extendTrial", userMembershipData?.extendTrial)
            console.log("kudzupluswhatis this", kudzuPlusTrue)
            const modalContent = userMembershipData?.membershipType === "Plus"
            ? (<p>{t("KudzuPlus_Cancellation_SubHeading")}</p>)
            : (
                <p>
                    {t("By_Cancelling")}
                    <span className='font-bold'>
                        {t("Kudzu_update_link")}
                    </span>
                </p>
            );
            showAlertModalPlus(true, t("thanks"), t("Do_you_want_to_downgrade_to_Kudzu"),
            modalContent
            , true, true, t('Downgrade_to_Kudzu'), t('Cancel'), true, require('../../assets/kudzu-plus-images/K-plus-logo.png'), "", true, "#262B3A", '', true, '', false, true, false, true, false);
        }

    const handleMembership = () => {
        if (kudzuPlusTrue) {
           
            navigate("/Settings/managemembershipscreen")
           
        }
        else {
             navigate("/Settings/managemembershipscreen")
        }
    }

    const handleRedirectFeaturesAndBenfits = () => {
        if (kudzuPlusTrue) {
            logFirebaseEvents("Setting", "Manage_Membership_Clicked", "Manage_Membership_Clicked", "", "");
            navigate("/Settings/manageMembershipKudzuplus")
        }
        else {
            logFirebaseEvents("Setting", "Manage_Membership_Clicked", "Manage_Membership_Clicked", "", "");
            navigate("/Settings/ManageMembershipKudzu")
        }
    }

   const handleBasicKudzuMembership =()=>{
        navigate("/Settings/ManageMembershipKudzu")
    }

   const handleSavingGoalClick = () => {
        navigate("/Toolkit/ToolkitMenu")
    }

    const handleCoveredByCudzuPlusClick = ()=> {
        navigate("/Toolkit/ToolkitMenu")
    }

    const handleSpendsAlertClick = () =>{
        navigate("/Toolkit/ToolkitMenu")
    }

    const handleSavingHabitsClick =()=>{
        navigate("/Toolkit/ToolkitMenu")
    }


    const handleLogout = async () => {
        debugger
        sessionStorage.removeItem('plusModalClosedHome');
        global.isLoggedIn = false
        global.accessTokenReload = accessTokenToApi
        logoutManually();
    };

    const logoutManually = async () => {
        if (global.accessTokenReload != '' && global.accessTokenReload != undefined) {
            var url = END_SESSION(isB2c, appConfigData.AUTH_URL, appConfigData.B2C_END_SESSION_URL, appConfigData.CLIENT_ID, global.accessTokenReload, appConfigData.POST_LOGOUT_REDIRECT_URI);
            window.location.replace(url);
            store.dispatch({ type: 'LOGOUT' });
        }
    }

    const leftBarComp = () => {
        return (
            <div className='md:w-[270px] sm:w-[159px]  w-full sm:px-0 pl-[2.5rem]' >

                <p className="text-white font-normal 
               lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px]
                sm:leading-[30px] leading-[31px]
          font-serif-pro sm:border-b-[2.5px] sm:border-[#4B70B9] lg:pb-14 md:pb-[50px] sm:border-opacity-[50%] border-b-0
          sm:pb-[2.6rem] pb-[2.6rem] mb-10">{t("setting_heading")}</p>

                <div className='flex flex-col md:gap-10 gap-8 sm:pb-0 pb-10'>
                    <Link 
                        to="/Settings/notificationConfigure"
                        className='flex flex-row justify-between items-center border-b-[2.5px] border-[#4B70B9] border-opacity-[50%] sm:border-b-0 pb-10 sm:pb-0 w-[80%] text-left' 
                        onClick={() => { setFocusedIndex(1); logFirebaseEvents("Setting", "Configuration_Notification_Clicked", "Configuration_Notification_Clicked", "", ""); }}
                        onFocus={() => setFocusedIndex(1)}
                    >
                        <span className={settingListItem}>
                            {t("configure_notifications")}
                        </span>
                        <img src={arrow} alt='arrow' className='flex sm:hidden h-[12px] w-[7px] mr-6' />
                    </Link>
                    <Link 
                        to="/Settings/ManageAccounts"
                        className={`${settingListItem} text-left`}
                        onFocus={() => setFocusedIndex(2)}
                        onClick={() => { setFocusedIndex(2); logFirebaseEvents("Setting", "Manage_Account_Clicked", "Manage_Account_Clicked", "", ""); }}
                    >
                        {t("manage_accounts")}
                    </Link>
                    {cards != null && cards.length > 0 && cards[0].AllowBeneficiaries &&
                        <Link 
                            to="/Settings/manageBeneficiaries"
                            className='flex flex-row justify-between items-center border-b-[2.5px] border-[#4B70B9] border-opacity-[50%] sm:border-b-0 pb-10 sm:pb-0 w-[80%] text-left' 
                            onClick={() => { setFocusedIndex(3); }}
                            onFocus={() => setFocusedIndex(3)}
                        >
                            <span className={settingListItem}>
                                {t("manage_beneficiaries")}
                            </span>
                            <img src={arrow} alt='arrow' className='flex sm:hidden h-[12px] w-[7px] mr-6' />
                        </Link>
                    }


                    {cards != null && cards.length > 0 && cards?.[0]?.ProgramKey === 200 && cards?.[0]?.AllowExternalAccounts && 
                        <Link 
                            to="/Settings/ManageExternalAccounts"
                            className='flex flex-row justify-between items-center border-b-[2.5px] border-[#4B70B9] border-opacity-[50%] sm:border-b-0 pb-10 sm:pb-0 w-[80%] text-left' 
                            onClick={() => { setFocusedIndex(4); logFirebaseEvents("Setting", "Manage_External_Account_Clicked", "Manage_External_Account_Clicked", "", "") }}
                            onFocus={() => setFocusedIndex(4)}
                        >
                            <span className={settingListItem}>
                                {t("manage_external_accounts")}
                            </span>
                            <img src={arrow} alt='arrow' className='flex sm:hidden h-[12px] w-[7px] mr-6' />
                        </Link>
                    }

                    {((!kudzuPlusTrue && showPrompt) || (isSmiOneIsTrue && showPrompt)) && 
                        <Link 
                            to="/Settings/ManageMembershipKudzu"
                            className='flex flex-row gap-2 items-center border-b-[2.5px] border-[#4B70B9] border-opacity-[50%] sm:border-b-0 pb-10 sm:pb-0 w-[80%] text-left'
                            onFocus={() => setFocusedIndex(5)}
                            onClick={() => { setFocusedIndex(5); }}
                        >
                            <span className={settingListItem}>
                                {'Manage Membership'}
                            </span>
                            <img src={dotCircle} alt='dot' />
                        </Link>
                    }

                    {kudzuPlusTrue &&  hasKudzuCard &&
                        <Link 
                            to="/Settings/managemembershipscreen"
                            className='flex flex-row items-center border-b-[2.5px] border-[#4B70B9] border-opacity-[50%] mr-[5px] sm:border-b-0 pb-10 justify-between sm:pb-0 w-[80%] text-left'
                            onFocus={() => setFocusedIndex(5)}
                            onClick={() => { setFocusedIndex(5); }}
                        >
                            <span className={settingListItemManageMember}>
                                {'Manage Membership'}
                            </span>
                            <div
                                className={`bg-[#2965FB] flex items-center text-white
                        justify-center text-center w-auto px-[15px] md:h-[25px] sm:h-[20px] h-[20px] rounded-[89px]
                        lg:text-[14px] md:text-[12px] sm:text-[12px] text-[12px] font-semibold font-hanken-grotesk`}
                            >
                                {promoKey == PAID_PROMO_KEY ? "Trial" : "Plus"}
                            </div>
                        </Link>
                    }

                    {
                        !isSmiOneIsTrue && (
                            <Link 
                                to="/Settings/ConnectSchool"
                                className='flex flex-row justify-between items-center border-b-[2.5px] border-[#4B70B9] border-opacity-[50%] sm:border-b-0 pb-10 sm:pb-0 w-[80%] text-left'
                                onClick={() => { setFocusedIndex(6); }}
                                onFocus={() => setFocusedIndex(6)}
                            >
                                <span className={settingListItem}>
                                    {t("connect_school")}
                                </span>
                                <img src={arrow} alt='arrow' className='flex sm:hidden h-[12px] w-[7px] mr-6' />
                            </Link>
                        )
                    }

                     {
                        !isSmiOneIsTrue && (
                            <button 
                                type="button"
                                className='flex flex-row justify-between items-center border-b-[2.5px] border-[#4B70B9] border-opacity-[50%] sm:border-b-0 pb-10 sm:pb-0 w-[80%] text-left'
                                onClick={handleLogout}
                            >
                                <span className={settingListItem}>
                                    {t("Sign Out")}
                                </span>
                                <img src={arrow} alt='arrow' className='flex sm:hidden h-[12px] w-[7px] mr-6' />
                            </button>
                        )
                    }
                </div>
            </div >
        )
    }

    const settingChildren1 = () => {
        return (
            <>
                <div className="sm:flex block flex-row justify-between  md:py-20 sm:py-8 py-12 md:mx-0 mx-4">
                    <div className='flex flex-col lg:w-[406px] md:w-[321px] w-[263px]'>

                        <p className="text-[var(--settings-heading-color)] font-normal 
                        leading-[30px] md:leading-[24px] lg:text-[32px] md:text-[30px]
                         sm:text-[18px] text-[25px] lg:leading-[38px] 
                          font-serif-pro">{t("settings")}</p>

                        <p className='mt-4   font-[400px] text-[var(--settings-body-color)]
                                    md:text-[20px] sm:text-[12px] text-[14px]
                                    md:leading-[30px] sm:leading-[20px] leading-[20px]
                       lg:w-[406px] md:w-[333px] sm:w-[250px]
                      lg:h-[252px] md:h-[175px] h-[170px] sm:font-medium font-hanken-grotesk
                        '>{t("settings_card1_content")}</p>
                    </div>
                    <div className='flex justify-center sm:pb-0 pb-20'>
                        <img src={appThemeData.SettingIcon} alt="setting" className='lg:w-[120px] md:w-[100px] sm:w-[92px] 
                                    lg:h-[120px] md:h-[100px] sm:h-[92px] h-[120px] w-[120px]' />
                    </div>
                </div>

            </>
        )
    }



    const features = [
        {
            icon: Ach_acces,
            text: "Access direct deposits up to 2 days early",
            endIcon: Checkbox,
            id: "achAccess"
        },
        {
            icon: SavingsInteresrRate,
            text: "1.26% Annual Percentage Yield (APY) on savings",
            endIcon: hasSavingsAccount ? GradientArrow : Security,
            id: "savingsInteresrRate"
        },
        {
            icon: CoveredbyKudzuplus,
            text: (
                <>
                    Additional exclusive features like{" "}
                    <span className="text-[#8AB4F8] cursor-pointer font-medium" onClick={handleSavingGoalClick}>Savings Goals</span>{" "}
                    <br></br> and overdraft protection with{" "}
                    <span className="text-[#8AB4F8] cursor-pointer font-medium" onClick={handleCoveredByCudzuPlusClick}>Covered by Kudzu+</span>
                </>
            ),
            endIcon: Checkbox,
            id: "coveredByKudzuPlus"
        },
        {
            icon: ATM_small,
            text: "No Out-of-Network ATM Withdrawal Fees",
            endIcon: GradientArrow,
            id: 'ATMWithdrawals'
        }
    ];

    const gradientIconLength = features?.filter((gradientIcon) => gradientIcon?.endIcon === GradientArrow)?.length

    const footerContentTwo = () => {
        
         return (
            <FooterContent 
            highlightText={"Kudzu"}
            highlightTextColor={true}
            subHeaderTextColor={true}
            subHeaderText={
               <ul className="space-y-16 w-full ml-0 sm:ml-2 md:ml-20">
              <li className="flex items-start gap-5 space-x-4">
                <img src={image} alt="check" className="w-6 h-6 mt-1" />
                <span className="text-[18px] font-[400] leading-relaxed">0.75% Annual Percentage Yield (APY) on savings</span>
              </li>
              <li className="flex items-start gap-5 space-x-4">
                <img src={image} alt="check" className="w-6 h-6 mt-1" />
                <span className="text-[18px] font-[400] leading-relaxed">Fee-free withdrawals at 55,000+ in-network Allpoint® ATMs.</span>
              </li>
              <li className="flex items-start gap-5 space-x-4">
                <img src={image} alt="check" className="w-6 h-6 mt-1" />
                <span className="text-[18px] font-[400] leading-relaxed">
                  Access to <Link to="/Toolkit/ToolkitMenu" className="text-[#4B70B9] cursor-pointer">Covered by Kudzu</Link>,
                  <Link to="/Toolkit/ToolkitMenu" className="text-[#4B70B9] cursor-pointer">&nbsp; SpendSense Alerts</Link> and
                  <Link to="/Toolkit/ToolkitMenu" className="text-[#4B70B9] cursor-pointer ">&nbsp; Savings Habits</Link>
                </span>
              </li>
            </ul>
            } 
            isSpace={true}
            image={kudzuLogo} 
            imageheight={true}
            isSubheadingwidth={false}
            type={t("manageSettingFooter")}
            backgroundColor={true}
            />
        )
      };

    const settingChildren2 = () => {
        return (
            <>
                <div className='w-[100%] flex flex-col justify-center mt-0 items-center sm:mx-0 mx-4 mb-10'>
                    <div className='w-[90%] text-white'>

                        <div className="flex flex-col gap-14 mt-4 ml-[12%]">
                            {features.map((feature, index) => (
                                <div key={index} className="flex justify-between items-center ">
                                    <div className="flex items-center gap-4"
                                    >
                                        <img src={feature.icon} alt={feature.text} className='w-8 h-8' />
                                        <p className="font-[500] font-hanken-grotesk md:text-[18px] sm:text-[13px]  tracking-[1px]">{feature.text}</p>
                                    </div>

                                </div>
                            ))}
                        </div>
                         <div className='mt-10'>
                            {userMembershipData?.membershipType === 'Plus' && (
                                <>
                                    {/* --- Desktop View --- */}
                                    <div className="hidden sm:flex items-center justify-between mt-4">
                                        <button
                                            type='button'
                                            onClick={handleCancelMembership}
                                            className="text-[#94C3E8] font-normal ml-[12%] cursor-pointer"
                                        >
                                            {userMembershipData?.extendTrial ? (<></>) : (t("CancelPlusMemberShip"))}
                                        </button>
                                        <button
                                            type="button"
                                            className="flex cursor-pointer items-center justify-center rounded-full w-auto h-[55px] border-2 border-[#30BC89] p-[2px] text-white text-[14px] leading-[13px] font-[700] font-hanken-grotesk"
                                            style={{ marginRight: "40px" }}
                                        >
                                            <div className="flex h-full items-center justify-center rounded-full w-full bg-[#324261] px-6 text-[14px]">
                                                <span className='cursor-pointer whitespace-nowrap' onClick={() => handleRedirectFeaturesAndBenfits()}>Explore Full Features & Benefits</span>
                                            </div>
                                        </button>
                                    </div>


                                    {/* --- Mobile View (UPDATED BUTTON) --- */}
                                    <div className="flex flex-col items-center sm:hidden mt-4 space-y-4 w-full px-4">
                                        <button
                                            type="button"
                                            onClick={() => handleRedirectFeaturesAndBenfits()}
                                            className="rounded-full w-full h-[55px] border-1 border-[#30BC89] p-[2px]"
                                        >
                                            <div className="flex h-full w-full items-center justify-center rounded-full bg-[#324261] font-bold text-white">
                                                Explore Full Features & Benefits
                                            </div>
                                        </button>
                                        <button
                                            type='button'
                                            onClick={handleCancelMembership}
                                            className="text-[#94C3E8] font-normal cursor-pointer"
                                        >
                                           {userMembershipData?.extendTrial ? (<></>) : (t("CancelPlusMemberShip"))}
                                        </button>
                                    </div>
                                </>
                            )}


                            {userMembershipData?.membershipType === 'Trial' && (
                                <>
                                    {/* --- Desktop View --- */}
                                    <div className="hidden sm:flex items-center justify-between mt-4">
                                        <button
                                            type='button'
                                            onClick={handleCancelMembership}
                                            className="text-[#94C3E8] font-normal ml-[12%] cursor-pointer"
                                        >
                                            {t("CancelTriaMemberShip")}
                                        </button>
                                        <button
                                            type="button"
                                            className="flex cursor-pointer items-center justify-center rounded-full w-auto h-[55px] border-2 border-[#30BC89] p-[2px] text-white text-[14px] leading-[13px] font-[700] font-hanken-grotesk"
                                            style={{ marginRight: "40px" }}
                                        >
                                            <div className="flex h-full items-center justify-center rounded-full w-full bg-[#324261] px-6 text-[14px]">
                                                <span className='cursor-pointer whitespace-nowrap' onClick={() => handleRedirectFeaturesAndBenfits()}>
                                                    {loggedResponse.Subscription.TrailRemainingDays === 0 ? (<>Explore Full Features & Benefits</>):( <>
                                                                                <span>{loggedResponse.Subscription.TrailRemainingDaysText}</span>&nbsp;Remaining
                                                    </>)}
                                                   
                                                    
                                                </span>
                                            </div>
                                        </button>
                                    </div>


                                    {/* --- Mobile View (UPDATED BUTTON) --- */}
                                    <div className="flex flex-col items-center sm:hidden mt-4 space-y-4 w-full px-4">
                                        <button
                                            type="button"
                                            onClick={() => handleRedirectFeaturesAndBenfits()}
                                            className="rounded-full w-full h-[55px] border-1 border-[#30BC89] p-[2px]"
                                        >
                                            <div className="flex h-full w-full items-center justify-center rounded-full border-2 border-[#30BC89] font-bold text-white">
                                                Explore Full Features & Benefits
                                            </div>
                                        </button>
                                        <button
                                            type='button'
                                            onClick={handleCancelMembership}
                                            className="text-[#94C3E8] font-normal cursor-pointer"
                                        >
                                            {t("CancelTriaMemberShip")}
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>

                    </div>
                </div>
            </>
        )
    }


    useKeyDown(() => {
        debugger;
        switch (focusedIndex) {
            case 1:
                navigate("/Settings/notificationConfigure");
                break;
            case 2:
                navigate("/Settings/ManageAccounts");
                break;
            case 3:
                navigate("/Settings/manageBeneficiaries");
                break;
            case 4:
                navigate("/Settings/ManageExternalAccounts");
                break;
            case 5:
                handleMembership();
                break;
            case 6:
                navigate("/Settings/ConnectSchool");
                break;
            default:
                break;
        }
    }, ["Enter"]);

    const footerContent = () => {

        return (
            <FooterContent 
            highlightText={t("settings_card2_content1")}
            subHeaderText={t("settings_card2_content2")} 
            isSpace={true}
            image={appThemeData.BellIconShow} 
            buttonEnabled={true}
            buttonText={t("configure_notifications")}
            footerBtnAction={() => { navigate("/Settings/notificationConfigure") }}
            isSubheadingwidth={false}
            type={"settings_card2_content1"}
            highlightTextColor={kudzuPlusTrue ? "#94c3e8" :"#2965FB"}
            subHeaderTextColor={kudzuPlusTrue ? "#ffffff" :"262B3A"}
            />
        )
    }
    return (
        <HomeLayout>
            <LeftBar leftBarType='component' isPrimary={true} leftBarComp={leftBarComp()} />

            <div className='md:w-[150px] sm:w-[70px] w-[0px]'></div>

            <div className='flex flex-col md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight'>
                {isShowManageMemberShip ? (
                    <CardSection CardRadius={true} IsProgress={'#324261'}>
                        <CardHeader>
                            <CardHeading heading={t('Kudzu+')} imageEnd={true} image={Approved} />
                        </CardHeader>
                        {settingChildren2()}
                    </CardSection>
                ) : (
                    <DynamicCard
                        header={true}
                        CardRadius={true}
                        cardWidth={width.homeCard}
                        HeaderRadius={true}
                        HeaderContent={false}
                        isWhite={appThemeData.isWhiteBgForCard}
                        isDarkForKudzu={appThemeData.isDarkBgForCard}
                    >
                        {settingChildren1()}
                    </DynamicCard>
                )}

                {isShowManageMemberShip ? (
                    <>
                        {footerContentTwo()}
                    </>
                ) : (
                    <>
                        {footerContent()}
                    </>
                )}
            </div>

            <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
              onBack={() => {
               if (comparisonClickFrom == 'cancelledSuccesfully') {
                  handleComparisonBackClick()
               } else {
                closeModelPlus()
               }
               }}
                image={modelImage}
                carousel={carousel}
                isBorderNone={isBorderNone}
                highlightMsg={<p className={HeaderMsgStylesForPlus}><span className='text-[#94C3E8] font-serif-pro'>{btn1Text === t('Downgrade_to_Kudzu') ? t('are_you_sure') : ""}</span><span>{headerMsg}</span></p>}
                subHeaderMsg={<p className={SubHeaderMsgPlusStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                borderGradientrouneded={true}
                btn1TextColor={btn1TextColor ? btn1TextColor : '#94C3E8'}
                btn2TextColor={'#779CE5'}
                borderWhite={'2px solid #94C3E8'}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text}
                btn1BgColor={btn1BgColor}
                btn2Text={btn2Text}
                opacityLow={opacityValueLow}
                defaultCornerRadius={false}
                btn1TypeAcpt={btn1TypeAcpt}
                onAcptBtnClick={onAcptBtnClickPlusModal}
                onCancelBtnClick={onCancelBtnClickPlusModal}
                gradientButton={gradientButton}
                largeImage={largeImage}
                allButtonsDisable={allButtonsDisable}
                footerText={footerText}
                comparisonScreen={comparisonScreen}
                fullWidth={fullWidth} 
            />
        </HomeLayout >
    )
}

export default withOidcSecure(Settings)